import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redireccionaurl',
  templateUrl: './redireccionaurl.component.html',
  styleUrls: ['./redireccionaurl.component.css']
})
export class RedireccionaurlComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.location.href = 'https://www.sportfishingmx.com'

  }

}
